import { render, staticRenderFns } from "./dialognoticias.vue?vue&type=template&id=63a45b18&scoped=true&"
import script from "./dialognoticias.vue?vue&type=script&lang=js&"
export * from "./dialognoticias.vue?vue&type=script&lang=js&"
import style0 from "./dialognoticias.vue?vue&type=style&index=0&id=63a45b18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a45b18",
  null
  
)

export default component.exports